import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "cfmr-admin-token";

export function getAdminToken() {
    try {
        return localStorage.getItem(ADMIN_TOKEN_KEY);
    } catch (e) {
        if (process.env.NODE_ENV !== "production")
            console.debug("localStorage read failed:", e);
        return null;
    }
}
export function setAdminToken(token) {
    try {
        if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
        else localStorage.removeItem(ADMIN_TOKEN_KEY);
    } catch (e) {
        if (process.env.NODE_ENV !== "production")
            console.debug("localStorage write failed:", e);
    }
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const t = getAdminToken();
    if (t && config.url && config.url.includes("/admin/")) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export const listScooters = () => api.get("/scooters").then((r) => r.data);
export const getScooter = (id) => api.get(`/scooters/${id}`).then((r) => r.data);
export const checkAvailability = (payload) =>
    api.post("/availability", payload).then((r) => r.data);
export const getQuote = (payload) =>
    api.post("/quote", payload).then((r) => r.data);
export const createCheckout = (payload) =>
    api.post("/bookings/checkout", payload).then((r) => r.data);
export const paymentStatus = (sessionId) =>
    api.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const submitContact = (payload) =>
    api.post("/contact", payload).then((r) => r.data);

// Heroes discount
export const submitHeroesRequest = (formData) =>
    api
        .post("/heroes/request", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        })
        .then((r) => r.data);
export const validateCoupon = (code) =>
    api.post("/coupons/validate", { code }).then((r) => r.data);

// Admin
export const adminLogin = (payload) =>
    api.post("/admin/login", payload).then((r) => r.data);
export const listHeroesRequests = () =>
    api.get("/admin/heroes/requests").then((r) => r.data);
export const approveHero = (id) =>
    api.post(`/admin/heroes/requests/${id}/approve`).then((r) => r.data);
export const rejectHero = (id) =>
    api.post(`/admin/heroes/requests/${id}/reject`).then((r) => r.data);
export const heroDocumentUrl = (id) => {
    const t = getAdminToken();
    return `${API}/admin/heroes/requests/${id}/document${t ? `?_t=${Date.now()}` : ""}`;
};
